import { LoggedUserType } from "../models/GlobalModels";
import { API_RESPONSE_CODE, STORAGE_KEY } from "./Constant";
// import { SHA256, Base64 } from 'crypto-es';

import {SHA256, Base64} from "crypto-es";


import { customAlphabet } from "nanoid/non-secure";

export const clearSession = () => {
  sessionStorage.clear(); //clear outlook detail
};

export const getFromLocalStorage = (key: string) => {
  const data = localStorage.getItem(key);
  return data ? data : "";
};

export const removeFromLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const saveInLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export const isAPIFailed = (fulfilled: any) => {
  if (
    fulfilled.responseInformation &&
    fulfilled.responseInformation &&
    fulfilled.responseInformation.responseCode === API_RESPONSE_CODE.FAIL
  ) {
    return true;
  } else {
    return false;
  }
};
export const isAPISuccess = (fulfilled: any) => {
  if (
    fulfilled.responseInformation &&
    fulfilled.responseInformation &&
    fulfilled.responseInformation.responseCode === API_RESPONSE_CODE.SUCCESS
  ) {
    return true;
  } else {
    return false;
  }
};

export const getUser = (): LoggedUserType => {
  let user: LoggedUserType = {
    candidateId: 0,
    candidateUniqueId: "",
    employeeUniqueId: "",
    firstname: "",
    lastName: "",
    employeeName:"",
    userActivationStatus: 0,
    userActivationStatusName: "",
    accessToken: "",
    accessExpiryTime: "",
    resetToken: "",
    resetExpiryTime: "",
    mobileNumber: 0,
    emailId: "",
    loginType: 0,
    loginTypeName: "",
    roleId: -1,
    permissions: [],
    roleName: '',
    userId: "",
    sessionId: ''
  };
  const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
  if (data) {
    user = JSON.parse(data);
  }
  return user;
};

export const regionContainingPoints = (points: any) => {
  let minLat: number, maxLat: number, minLng: number, maxLng: number;

  // Initialize first point
  ((point) => {
    minLat = point.centroid.lat;
    maxLat = point.centroid.lat;
    minLng = point.centroid.lng;
    maxLng = point.centroid.lng;
  })(points[0]);

  // Calculate rect points
  points.forEach((point: any) => {
    minLat = Math.min(minLat, point.centroid.lat);
    maxLat = Math.max(maxLat, point.centroid.lat);
    minLng = Math.min(minLng, point.centroid.lng);
    maxLng = Math.max(maxLng, point.centroid.lng);
  });

  const midLat = (minLat + maxLat) / 2;
  const midLng = (minLng + maxLng) / 2;
  // const deltaLat = maxLat - minLat;
  // const deltaLng = maxLng - minLng;

  return {
    lat: midLat,
    lng: midLng,
  };
};

export const dateConverter = (sdate: string, datetype : string) => {
  let fromDate = new Date(sdate);
  let toDate = new Date(sdate);
  let convertedDate;
    if(datetype === "fromDate"){
      convertedDate = fromDate.setDate(fromDate.getDate() );
    }else {
      convertedDate = toDate.setDate(toDate.getDate() + 1);
    }

  var date = new Date(convertedDate);
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let day = ("0" + date.getDate()).slice(-2);
  return `${date.getFullYear()}-${month}-${day}`;
};

export const dateConverterWithoutAddingDays = (sdate: string, datetype : string) => {
  let fromDate = new Date(sdate);
  let toDate = new Date(sdate);
  let convertedDate;
    if(datetype === "fromDate"){
      convertedDate = fromDate.setDate(fromDate.getDate());
    }else {
      convertedDate = toDate.setDate(toDate.getDate());
    }

  var date = new Date(convertedDate);
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let day = ("0" + date.getDate()).slice(-2);
  return `${date.getFullYear()}-${month}-${day}`;
};

export const isWithin30Meters = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) => {
  // Radius of earth in kilometers
  var R = 6371.0;

  // Convert degrees to radians
  var lat1Rad = toRadians(lat1);
  var lon1Rad = toRadians(lon1);
  var lat2Rad = toRadians(lat2);
  var lon2Rad = toRadians(lon2);

  // Differences
  var dlat = lat2Rad - lat1Rad;
  var dlon = lon2Rad - lon1Rad;

  // Haversine formula
  var a =
    Math.sin(dlat / 2) ** 2 +
    Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dlon / 2) ** 2;
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  // Distance in kilometers
  var distance = R * c;

  // Convert distance to meters and check if it's less than or equal to 30
  return distance * 1000 <= 30;
};

export const toRadians = (degrees: number) => {
  return degrees * (Math.PI / 180);
};

export const getAccessToken = (): string => {
  const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
  if (data) {
    try {
      const parsed = JSON.parse(data);
      return parsed.accessToken || '';
    } catch {
      return '';
    }
  }
  return '';
};



// Define the character set for PKCE (Proof Key for Code Exchange)
// This character set is compliant with the PKCE specification.
const chars =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";

// Create a custom nanoid generator with the defined character set and a length of 64.
// This will generate a random string of 64 characters.
const nanoid = customAlphabet(chars, 64);

// Generate a random code verifier using the nanoid generator.
// The code verifier is a high-entropy cryptographic random string used in PKCE.
const generateCodeVerifier = (): string => {
  return nanoid();
};

// Generate a SHA256 challenge from the code verifier.
// The challenge is a Base64 URL-encoded SHA256 hash of the verifier, used in PKCE.
const generateChallenge = (verifier: string) => {
  try {
    // Create a SHA256 hash of the verifier.
    const hash = SHA256(verifier);

    // Convert the hash to a Base64 string and make it URL-safe by:
    // - Replacing '+' with '-'
    // - Replacing '/' with '_'
    // - Removing any trailing '=' padding
    const base64 = hash
      .toString(Base64)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");

    return base64;
  } catch (error) {
    // Log an error if the challenge generation fails.
    console.error("Error generating challenge:", error);
    return "";
  }
};

// Function that returns both verifier and challenge
export const generatePKCEParams = () => {
  const verifier = generateCodeVerifier();
  const challenge = generateChallenge(verifier);
  return { verifier, challenge };
};
